export default __webpack_public_path__ + "static/media/dcfcWiredLearnMore.bd37d4c0.png";